import { styled, TextField, TextFieldProps } from "@mui/material";

export const TextFieldCustom = styled((props: TextFieldProps) => <TextField {...props} />)(({ theme }) => ({
    "& .MuiOutlinedInput-input": {
        paddingTop: "6px",
        paddingBottom: "6px",
        textAlign: "center",
        fontFamily: "var(--font-mono)",
        fontWeight: 500,
        fontVariantNumeric: "tabular-nums",
        fontSize: "12px",
        color: theme.palette.text.secondary,
    },
}));
